export class Asegurado {
    Guid: string;
    Rut: string;
    Nombre: string;
    Apellido: string;
    Email: string;
    FechaNacimiento: Date;
    TipoPersona: string;
    RazonSocial: string;
    CodigoComuna: number;
    Direccion: string;
    TelefonoMovil: string;
    SexoID: number;
    Sexo: string;
    Chasis: string;
    Color: string;
    Motor: string;
    Sucursal: string;
    UserId: string;

    constructor() {
      this.Guid = '';
      this.Rut = '';
      this.Nombre = '';
      this.Apellido = '';
      this.FechaNacimiento = new Date();
      this.CodigoComuna = 305; // Santiago
      this.Direccion = '';
      this.TipoPersona = 'Natural';
      this.RazonSocial = 'Sin Razon social';
      this.TelefonoMovil = '';
      this.SexoID = -1;// Sin setear
      this.Sexo = '';
      this.Chasis = '';
      this.Color = '';
      this.Motor = '';
    }
}
